module.exports = __webpack_public_path__ + "static/img/lunbo1.ad7a3c49.webp";